import { render, staticRenderFns } from "./IntroDrawer.vue?vue&type=template&id=706d2c92&scoped=true"
import script from "./IntroDrawer.vue?vue&type=script&lang=ts"
export * from "./IntroDrawer.vue?vue&type=script&lang=ts"
import style0 from "./IntroDrawer.vue?vue&type=style&index=0&id=706d2c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d2c92",
  null
  
)

export default component.exports